import { render, staticRenderFns } from "./Ratings.vue?vue&type=template&id=cec40086&scoped=true&"
import script from "./Ratings.vue?vue&type=script&lang=js&"
export * from "./Ratings.vue?vue&type=script&lang=js&"
import style0 from "./Ratings.vue?vue&type=style&index=0&id=cec40086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec40086",
  null
  
)

export default component.exports